export type ProjectQuotesAndDesignsResponse = {
  customerQuotes: Array<CustomerQuotesResponse>;
  designs: Array<DesignResponse>;
};

export type CustomerQuotesResponse = {
  customerId: number;
  name: string;
  customerReference: string;
  quotes: Array<CustomerQuoteResponse>;
};

type HeatPumpType = 'Air Source' | 'Ground Source with Ground Loops' | 'Ground Source with Borehole';

export type CustomerQuoteResponse = {
  quoteId: number;
  name: string;
  underfloorHeatingNetSuiteQuoteReference: string | null;
  heatPumpNetSuiteQuoteReference: string | null;
  solarNetSuiteQuoteReference: string | null;
  createdDateTime: string;
  createdBy: string;
  uploadedDateTime: string | null;
  heatPumpType: HeatPumpType | null;
  includesSolar: boolean;
  hasBillOfMaterials: boolean;
  isDraft: boolean;
};

export const isQuoteSubmitted = (quote: CustomerQuoteResponse): boolean => {
  return quote.uploadedDateTime != null;
};

export type DesignResponse = {
  designId: number;
  name: string;
  createdDateTime: string;
  createdBy: string;
  uploadedDateTime: string | null;
  heatPumpType: HeatPumpType | null;
  includesSolar: boolean;
  hasBillOfMaterials: boolean;
  isDraft: boolean;
  isMissingRequiredSalesOrder: boolean;
};
